import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

import IconButton from '../../elements/IconButton'
import Dropdown from '../../elements/ReactSelectDropdown'
import TextInput from '../../elements/TextInput'
import Button from '../../elements/Button'

import { useCookies } from 'react-cookie'

const Main = (props) => {

    const [cookies, setCookies] = useCookies([])

    let tempIndex = -1

    console.log(props)

    const [dealershipSpiffees, setDealershipSpiffees] = useState([])

    useEffect(() => {

        let tokenValues = {
            refresh_token: cookies['refresh_token'],
            refresh_token_expires: cookies['refresh_token_expires'],
            access_token: cookies['access_token'],
            access_token_expires: cookies['access_token_expires'],
        }

        //get dealers
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        };

        props.tokenSafeAPIRequest('/spiffee/dealership/' + props.selectedDealer.id, requestOptions, tokenValues, (result) => {
            console.log(result)
            let tempDealershipSpiffees = [];
            result.map((spiffee, index) => {
                tempDealershipSpiffees.push({value: spiffee.id, label: spiffee.first_name === null ? spiffee.name:spiffee.first_name + ' ' + spiffee.last_name})
            })
            tempDealershipSpiffees.push({value: 'dealership_spiff', label: props.selectedDealer.name})
            setDealershipSpiffees(tempDealershipSpiffees)
        })
    },[])

    const [spiffTypes, setSpiffTypes] = useState([
        { value: 'Visa', label: '$100 Visa' },
        { value: 'Visa', label: '$50 Visa' },
        // { value: 'Visa', label: '$25 Visa' },
        // { value: 'Amex', label: 'Amex' },
        { value: 'Check', label: 'Check' },
    ])

    const [shippingTypes, setShippingTypes] = useState([
        { value: 1, label: 'Dealer Address' },
        { value: 2, label: 'Spiffee Address' },
        { value: 3, label: 'Subagent Address' },
    ])

    const processSpifftype = (spiffType) => {
        if (spiffType === '$25 Visa') return 'Visa'
        else if (spiffType === '$50 Visa') return 'Visa'
        else if (spiffType === '$100 Visa') return 'Visa'
        else {return spiffType}
    }

    const [data, setData] = useState({
        spiffee: {id: '', name: ''},
        amount_per_contract: '',
        shipping_address: {id: '', name: ''},
        ATTN: '',
        spiff_type: {id: '', name: ''},
        fee: 0,
    })

    const onChange = (e, key) => {
        setData((data) => {
            return ({
                ...data,
                [key]: (key === 'spiffee' || key === 'shipping_address' || key === 'spiff_type') ? {id: e.value, name: e.label}:e,
                ...(key === 'spiff_type' && { fee: getGiftcardFee(e.label) }),
            })
        })
        if (key === 'spiff_type')
        {
            if (e.label === '$100 Visa') {onChange(100, 'amount_per_contract')}
            if (e.label === '$50 Visa') {onChange(50, 'amount_per_contract')}
            if (e.label === '$25 Visa') {onChange(25, 'amount_per_contract')}
        }
    }

    const clearReport = () => {
        setData({
            spiffee: {id: '', name: ''},
            amount_per_contract: '',
            shipping_address: {id: '', name: ''},
            ATTN: '',
            spiff_type: {id: '', name: ''},
            fee: 0,
        })
    }

    const getGiftcardFee = (spiffType) => {

        //get dealers
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          redirect: 'follow',
          body: JSON.stringify({}),
        };

        const nameTranslate = (backendName) => {
            if (backendName === '$50 Visa') {return 'Visa 50'}
            else if (backendName === '$25 Visa') {return 'Visa 25'}
            else if (backendName === '$100 Visa') {return 'Visa 100'}
            else {return backendName}
        }
    
        props.tokenSafeAPIRequest('/gift_card/search', requestOptions, '', (result, status) => {
            result.map((giftcard, index) => {
                if (nameTranslate(spiffType) === giftcard.name)
                {
                    console.log(giftcard)
                    return giftcard.final_fee
                }
            })
        })
    }

    return (
        <div style={{width: '360px', height: '530px', display: 'flex', flexDirection: 'column'}}>
            <div style={{flexBasis: '10%', display: 'flex', flexDirection: 'row'}}>
                <span style={{fontWeight: '500', fontSize: '20px', flexBasis: '99%'}}>Add Spiffee</span>
                <IconButton img={false} colors={props.colors} Style={{borderRadius: '3px', backgroundColor: props.colors.border}} size="16px">
                    <div onClick={props.setIsOpen} style={{paddingLeft: '3px', paddingRight: '3px'}}><span onClick={props.setIsOpen}>x</span></div>
                </IconButton>
            </div>
            <div style={{flexBasis: '90%', display: 'flex', flexDirection: 'column'}}>
                <span>Spiffee</span>
                <div style={{marginTop: '5px'}}><Dropdown colors={props.colors} onChange={(e) => onChange(e, 'spiffee')} index={props.index} indexParent={props.indexParent} data={dealershipSpiffees} value={data.spiffee.name}></Dropdown></div>
                {/* <div style={{display: 'flex', flexDirection: 'row', marginTop: '15px'}}>
                    <div style={{width: '19px', height: '19px', borderRadius: '4px', border: '' ? 'none':'1px solid ' + props.colors.border, backgroundColor: '' ? props.colors.primary:''}}></div>
                    <span style={{marginLeft: '10px'}}>Pre-Spiff Payoff</span>
                </div> */}
                <span style={{marginTop: '15px'}}>Amount / Contract</span>
                <TextInput Style={{marginTop: '5px'}} prefix="$" onChange={(e) => onChange(e, 'amount_per_contract')} colors={props.colors} data={data.amount_per_contract}></TextInput>
                <span style={{marginTop: '15px'}}>Shipping Address</span>
                <div style={{marginTop: '5px'}}><Dropdown colors={props.colors} onChange={(e) => onChange(e, 'shipping_address')} index={props.index} indexParent={props.indexParent} data={shippingTypes} value={data.shipping_address.name}></Dropdown></div>
                <span style={{marginTop: '15px'}}>ATTN</span>
                <TextInput Style={{marginTop: '5px'}} prefix="" onChange={(e) => onChange(e, 'ATTN')} colors={props.colors} data={data.ATTN}></TextInput>
                <span style={{marginTop: '15px'}}>Spiff Type</span>
                <div style={{marginTop: '5px'}}><Dropdown menuPlacement={'top'} colors={props.colors} onChange={(e) => onChange(e, 'spiff_type')} index={props.index} indexParent={props.indexParent} data={spiffTypes} value={data.spiff_type.name}></Dropdown></div>
                <Button onClick={() => {props.setIsOpen(); props.addSpiffee(data); clearReport();}} Style={{marginTop: '35px'}} active={true} colors={props.colors}>Add</Button>
            </div>
        </div>
    )
}

export default Main
